<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <div class="content1">
        <img src="../../assets/img/jieju/sh_settled in_banner.png" alt />
        <div class="content1_1">
          <span>
            商会入驻
            <span style="font-size:20px;font-weight:400;">&nbsp;&nbsp;&nbsp; 赋能商会信息化建设 助力民营经济发展</span>
          </span>
        </div>
      </div>
      <div class="content_1">
        <div class="content_1_one">
          <div class="conetent_cent">
            <div class="conetent_cent_1">
              <div class="conetent_cent_one">
                <p>
                  <span style="color:#FF4D43">*</span>商会名称：
                </p>
                <el-input placeholder="请输入内容" class="input2" v-model="from.name"></el-input>
              </div>
              <div class="conetent_cent_one">
                <p>
                  <span style="color:#FF4D43">*</span>简介：
                </p>
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="from.content"
                  class="input2"
                ></el-input>
              </div>
              <div class="conetent_cent_one">
                <p>
                  <span style="color:#FF4D43">*</span>详细地址：
                </p>
                <el-input placeholder="请输入内容" class="input2" v-model="from.address"></el-input>
              </div>
              <div class="conetent_cent_one">
                <p>
                  <span style="color:#FF4D43">*</span>联系电话：
                </p>
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="from.phone"></el-input>
                    <button @click="getCode()" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="conetent_cent_one">
                <p>
                  <span style="color:#FF4D43">*</span>验证码：
                </p>
                <el-input placeholder="请输入内容" class="input2" v-model="from.ecord"></el-input>
              </div>
            </div>
          </div>
          <div class="content_floor" @click="idem()">
            <a href="#">下一步</a>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li>
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoginphone } from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      from: {
        ecord: "",
        phone: "",
        address: "",
        name: "",
        content: ""
      },
      TIME_COUNT: 60, //验证码倒计时60s
      show: true,
      cang: false,
      count: ""
    };
  },
  methods: {
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    },
    getCode(from) {
      if (!/^1[34578]\d{9}$/.test(this.from.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.from.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.from.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    idem() {
      this.$http(
        "https://coc.sqifu.com/WebProgram/User/business_apply",
        {
          username: this.from.name,
          ecord: this.from.ecord,
          address: this.from.address,
          phone: this.from.phone,
          content: this.from.content
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 200) {
          this.$message({
            message: "提交成功！将有工作人员联系您，请您耐心等待。",
            type: "success"
          })
          this.$router.push({
            name:'home'
          })
        }
      });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.content {
  width: 100%;
  height: auto;
}

.content1 {
  width: 100%;
  height: 100px;
  position: relative;
}

.content1 img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.content1_1 {
  width: 940px;
  height: auto;
  margin: 0 auto;
}

.content1_1 span {
  line-height: 100px;
  font-size: 32px;
  color: #ffffff;
  font-weight: 600;
}

.content_1 {
  width: 100%;
  height: 708px;
  background: #f4f5f9;
  overflow: hidden;
}

.content_1_one {
  width: 940px;
  height: 554px;
  background: #fff;
  margin: 10px auto;
  overflow: hidden;
}

.content1_one {
  width: 750px;
  height: 49px;
  margin: 30px auto;
}

.conetent_cent {
  width: 470px;
  margin: 80px auto;
  background: #fff;
}

.conetent_cent_two {
  width: 100%;
  height: 66px;
  margin-bottom: 34px;
}

.conetent_cent_four {
  width: 100%;
  height: 148px;
  margin-bottom: 34px;
}

.conetent_cent_four p {
  width: 80px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_four span {
  margin-right: 5px;
}

.conetent_cent_two p {
  width: 80px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_two span {
  margin-right: 5px;
}

.conetent_cent_three {
  width: 100%;
  height: 148px;
  margin-bottom: 24px;
}

.conetent_cent_three p {
  width: 80px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_three span {
  margin-right: 5px;
}

.content_floor {
  width: 260px;
  height: 44px;
  background: #007bff;
  border-radius: 5px;
  text-align: center;
  margin: 0 auto;
}

.content_floor a {
  color: #fff;
  line-height: 44px;
}

.input {
  width: 699px;
}
.input2 {
  width: 336px;
}
.input2 {
  width: 336px;
  margin-bottom: 20px;
}

.input1 {
  width: 336px;
  height: 66px;
}

.conetent_cent_one {
  width: 100%;
  height: 36px;
  margin-bottom: 24px;
}

.conetent_cent_one p {
  width: 84px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_one span {
  margin-right: 5px;
}

.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  width: 458px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Jiejue/Shanghuiruzha.vue